module.exports = __webpack_public_path__ + "static/media/4j_website_logo_sup_hkastri.11b0545f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/home/partners_logos/4j_website_logo_sup_hkastri.jpg
// module id = 63
// module chunks = 0